import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface GridCell {
  cameraId: string | null;
  streamUrl: string | null;
}

interface GridState {
  template: '2x2' | '3x3' | '4x4';
  cells: GridCell[];
  setTemplate: (template: '2x2' | '3x3' | '4x4') => void;
  setCell: (index: number, cameraId: string, streamUrl: string) => void;
  removeCell: (index: number) => void;
  clearAll: () => void;
}

const TEMPLATES = {
  '2x2': 4,
  '3x3': 9,
  '4x4': 16,
};

export const useGridStore = create<GridState>()(
  persist(
    (set, get) => ({
      template: '2x2',
      cells: Array(TEMPLATES['2x2']).fill({ cameraId: null, streamUrl: null }),

      setTemplate: (template) => {
        const count = TEMPLATES[template];
        const currentCells = get().cells;
        set({
          template,
          cells: Array(count).fill(null).map((_, i) =>
            currentCells[i] || { cameraId: null, streamUrl: null }
          ),
        });
      },

      setCell: (index, cameraId, streamUrl) => {
        set((state) => ({
          cells: state.cells.map((cell, i) =>
            i === index ? { cameraId, streamUrl } : cell
          ),
        }));
      },

      removeCell: (index) => {
        set((state) => ({
          cells: state.cells.map((cell, i) =>
            i === index ? { cameraId: null, streamUrl: null } : cell
          ),
        }));
      },

      clearAll: () => {
        set((state) => ({
          cells: state.cells.map(() => ({ cameraId: null, streamUrl: null })),
        }));
      },
    }),
    {
      name: 'grid-storage',
    }
  )
);
